<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import perfilesCargoAPI from "../../../services/standards/perfilesCargo/perfilesCargoAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Perfiles de cargo - profesiograma",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "3.1.3 Perfiles de cargo - profesiograma",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Perfiles de cargo - profesiograma",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      types: [],
      lista: [],
      loading: true,
      loading2: true,

      itemData: null,

      item: null,

      itemData: null,

      file: null,

      yuju: [],

      perfil: {
        position: null,
        description_position: null,
        evaluations_types_id: [],
        frequency: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },

  validations: {
    perfil: {
      position: {
        required,
      },
      description_position: {
        required,
      },
      evaluations_types_id: {
        required,
      },
      frequency: {
        required,
      },
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(25)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 25)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getType() {
      perfilesCargoAPI.getTypes()
        .then((response) => {
          this.loading = false
          let types = response.data;
          this.types = types
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitted = false;
        return;
      } else {
        perfilesCargoAPI.update(this.$route.params.id, {
          position: this.perfil.position,
          description_position: this.perfil.description_position,
          evaluations_types_id: [this.perfil.evaluations_types_id],
          frequency: this.perfil.frequency,
          companies_id: this.perfil.companies_id,
        })
          .then((response) => {
            perfilesCargoAPI.updateE(this.$route.params.id, {
              profiles_job_descriptions_id: this.$route.params.id,
              evaluations_types_id: this.perfil.evaluations_types_id,
              companies_id: this.perfil.companies_id,
            })
              .then((response) => {
                const itemChange = {
                  companies_id: this.companyID,
                  item_id: 25,
                  status: 'Pendiente',
                };
                newScoresAPI.calculateScores(itemChange)
                  .then((response) => {
                    this.sendNotification(57, 25, true)
                    setTimeout(() => {
                      Swal.fire({
                        title: "Informacion actualizada con éxito!",
                        text: "Informacion actualizada con éxito!",
                        icon: "success",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      this.$router.go(-1);
                    }, 1000)
                  })
                  .catch((error) => {
                    this.loading = false
                    setTimeout(() => {
                      Swal.fire({
                        title: "Error",
                        text: "¡No se ha podido registrar!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      window.location.reload();
                    }, 1000);
                    console.log(error);
                  });



              }).catch((error) => {
                console.log(error);
                this.loading = false
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getShow() {
      perfilesCargoAPI
        .show(this.$route.params.id)
        .then((response) => {
          this.loading = false
          const arr = []
          for (let i = 0; i < response.data[1].length; i++) {
            this.yuju = response.data[1][i].exist_type_id;
            this.perfil = {
              position: response.data[0].position,
              description_position: response.data[0].description_position,
              frequency: response.data[0].frequency,
              companies_id: response.data[0].companies_id,
            };
            arr.push(response.data[1][i].exist_type_id)
          }
          this.perfil.evaluations_types_id = arr
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getType();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Tipos de evaluaciones">

                    <table
                      class=" table-sm pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">

                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="dato in types" :key="dato.id">
                          <td>
                            {{ dato.name }}
                          </td>
                          <td class="text-center align-middle">
                            <input type="checkbox" style="color: #666"
                              :checked="perfil.evaluations_types_id.some(type => type === dato.id)" :value="dato.id"
                              v-model="perfil.evaluations_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                          </td>

                        </tr>
                      </tbody>
                    </table>
                    <div v-if="submitted && $v.perfil.evaluations_types_id.$error">
                      <small v-if="!$v.perfil.evaluations_types_id" class="text-danger">
                        <b>El tipo de cambio es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Frecuencia">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="perfil.frequency" :class="{ 'is-invalid': $v.perfil.frequency.$error && submitted }">
                      <b-form-select-option value="Anual">
                        Anual
                      </b-form-select-option>
                      <b-form-select-option value="Dos años">
                        Dos años
                      </b-form-select-option>
                      <b-form-select-option value="Tres años">
                        Tres años
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.perfil.frequency.$error">
                      <small v-if="!$v.perfil.frequency.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2 mb-3" label="Cargo" label-for="file">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam"
                      maxlength="50" v-model="perfil.position"
                      :class="{ 'is-invalid': $v.perfil.position.$error && submitted }">
                    </b-form-input>
                    <div v-if="submitted && $v.perfil.position.$error">
                      <small v-if="!$v.perfil.position.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción del cargo" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate"
                      v-model="perfil.description_position" maxlength="200"
                      :class="{ 'is-invalid': $v.perfil.description_position.$error && submitted }">
                      >
                    </b-form-textarea>
                    <div v-if="submitted && $v.perfil.description_position.$error">
                      <small v-if="!$v.perfil.description_position.required" class="text-danger">
                        <b>La descripción es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>